<template>
    <div>
        <div style="width:100%;padding:5px;">
            <span class="btn btn-default" @click="loadItems">{{lang.common.refresh}}</span>
        </div>

        <paged-loading :is-loading="loadingImg" @pagechange="onPageChange" :paging-info="paging">
                <div>
                        <div class="panel panel-default" v-for="item in items">

                            <div class="panel-body">

                                <div>
                                    <h4>{{item.shop.shopName}} </h4>
                                    <div>
                                        <span style="font-weight:bold;"> {{lang.order.orderNum}}: {{item.id}} </span>
                                        <span style="color:gray;"> {{lang.common.date}}: {{item.localCreateDate}} </span>
                                    </div>


                                    <div style="text-align:right;">
                                        <router-link :to="{name:'orderDetail',query:{orderId:item.id}}">
                                            <div class="btn btn-default">
                                                <span>{{lang.stateLabels.order[item.stateCode]}} </span>
                                                <span class="glyphicon glyphicon-chevron-right"></span> 
                                                <span class="btn btn-primary">{{lang.order.detail}}</span>
                                            </div>
                                        </router-link>
                                    </div>

                                    <div>

                                        <div v-for="(orderItem,index) in item.items" class="act-order-item row" :order-id="orderItem.id" style="border-bottom:1px solid gray;">
                                            <div class="col-xs-8">
                                                <div class="col-xs-12">
                                                    <span style="font-weight:bold;">{{index+1}}.</span>
                                                    <span>{{orderItem.title}}</span>
                                                </div>
                                                <div class="col-xs-12">
                                                    <span v-for="pc in orderItem.propCats">
                                                        {{pc.parent.name}}:{{pc.child.name}}
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="col-xs-2">{{orderItem.price}} </div>
                                            <div class="col-xs-2">x {{orderItem.quant}} </div>
                                        </div>

                                        <div>{{lang.order.buyerMsg}}: {{item.userMsg}}</div>
                                        <div>{{lang.order.shopMsg}}: <span style="color:red;"> {{item.shopMsg}} </span></div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    
                </div>
        </paged-loading>
    </div>
</template>
<script>
    import pagedLoading from '../components/base/PagedLoading.vue';
    import queryString from '../utl/queryString';
    import modal from './base/Modal.vue';

    export default {
        components: {
            pagedLoading: pagedLoading,
            modal: modal
        },
        data: function () {
            return {
                paging: { page: 1, pageSize: 1, count: 1 },
                loadingImg: false,
                items: [],
                selectedOrder: null
            };
        },
        computed: {
            apiClient: function () {
                return this.mxnAgxApi.ordersApiClient;
            },
            lang: function () {
                return this.$store.getters.lang;
            }
        },
        methods: {
            reloadItems: function () {
                var obj = { uid: this.userId };
                this.loadItems(queryString().getString(obj));
            },
            onPageChange: function (newPage) {
                var obj = { page: newPage };
                this.loadItems(queryString().getString(obj));
            },
            loadItems: function (query) {
                this.items = [];//set items empty as user session may expired
                this.loadingImg = true;
                this.apiClient.getOrderListPrms(query).done((ret) => {
                    this.loadingImg = false;
                    var filter = ret.filter;
                    this.paging = { page: filter.page, pageSize: filter.pageSize, count: filter.count };
                    this.items = ret.items;

                }).fail((ret) => {
                    this.loadingImg = false;
                });
            }
        },
        created: function () {
            this.apiClient.onLoginApi.on(this.reloadItems);
            this.reloadItems();
        },
        destroyed: function () {
            this.apiClient.onLoginApi.remove(this.reloadItems);
        },
        mounted: function () {

        }
    }
</script>